<template>
  <div id="student-list">
    <Item
      v-for="item in student"
      :key="item.id"
      :data="item"
      @edit="$emit('edit', item)"
      @select="$emit('select', item.id)"
      :mode="mode"
      :selected="value === item.id"
    />
    <button @click="$emit('create')" class="btn-primary">
      <i class="anyteachicon anyteach-plus1" />
      新增学生
    </button>
  </div>
</template>

<script>
import Item from "./ListItem"
export default {
  props: ["mode", "value"],
  components: {
    Item
  },
  computed: {
    student() {
      return this.$store.state.user.student
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

#student-list {
  width: 100%;
}
</style>